import { render, staticRenderFns } from "./CabinPrice.vue?vue&type=template&id=6e01b0ae&"
import script from "./CabinPrice.vue?vue&type=script&setup=true&lang=js&"
export * from "./CabinPrice.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./CabinPrice.vue?vue&type=style&index=0&id=6e01b0ae&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports